import "./faq.css";

export const createFaq = () => {
  const faqContainers = document.querySelectorAll("[data-faq]");

  faqContainers.forEach(createFaqContainer);
};

const createFaqContainer = (container: Element) => {
  const items = Array.from(container.querySelectorAll("[data-faq-item]"));

  items.forEach((item) => {
    item.addEventListener("click", (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest("[data-faq-item-content]") === null
      ) {
        item.classList.toggle("is-active");
      }
    });
  });

  const blockToggles = Array.from(
    container.querySelectorAll(`[data-faq-toggle]`),
  );

  const blockExpands = Array.from(
    container.querySelectorAll(`[data-faq-expand-toggle]`),
  );

  const blocks = Array.from(container.querySelectorAll(`[data-faq-target]`));

  const setActiveBlock = (name: string) => {
    blockToggles.forEach((blockToggle) =>
      blockToggle.classList.toggle(
        "is-active",
        blockToggle.getAttribute("data-faq-toggle") === name,
      ),
    );

    blocks.forEach((block) => {
      block.classList.toggle(
        "is-active",
        block.getAttribute("data-faq-target") === name,
      );

      const lists = Array.from(block.querySelectorAll("[data-faq-list]"));

      lists.forEach((list) => {
        list.classList.toggle(
          "is-active",
          block.getAttribute("data-faq-target") === name,
        );
      });
    });
  };

  blockToggles.forEach((blockToggle) => {
    blockToggle.addEventListener("click", () => {
      const name = blockToggle.getAttribute("data-faq-toggle");

      if (name !== null) {
        setActiveBlock(name);
      }
    });
  });

  blockExpands.forEach((blockExpand) => {
    blockExpand.addEventListener("click", () => {
      const name = blockExpand.getAttribute("data-faq-expand-toggle");

      const isActive = blockExpand.classList.toggle("is-active");

      Array.from(
        container.querySelectorAll(
          `[data-faq-target="${name}"] [data-faq-list]`,
        ),
      ).forEach((list) => {
        list.classList.add("is-animating");
        list.classList.toggle("is-active", isActive);
      });
    });
  });
};
